<template>
    <div class="page" v-loading="loading">
        <div class="page-content" v-if="bookCon">
<!--            <div class="img-div">-->
<!--                <img class="rand_pic" src="@/assets/extension/img1.jpg" alt="My CEO Stepbrother Kissed me">-->
<!--            </div>-->
            <div id="copycontent" class="type8">
                <section class="content">
<!--                    <p class="innerTitle"><span>My CEO Stepbrother Kissed me</span></p>-->
                    <section class="boxbr" v-html="bookCon">
                        {{bookCon}}
                    </section>
                    <p class="tipInfo">Click to Install the app and Search [<b>{{copyCon}}</b>] for more exclusive exciting chapters. </p>
                </section>
            </div>
        </div>
        <div class="center" v-if="bookCon != ''">
<!--            <a class="download-btn" :data-clipboard-text="`haiwen_${copyCon}`" @click="downlowFun('andriod')" href="javascript:void(0);"><img src="../../assets/account/btn_android.png"/></a>-->
            <a class="download-btn" :data-clipboard-text="`InkTale_${copyCon}_${udid}`" @click="downlowFun('ios')" href="javascript:void(0);">CONTINUE READING</a><!--<img src="../../assets/account/btn_iphone.png"/>-->
        </div>
    </div>
</template>

<script>
    import "utils/lib/rem";
    import Clipboard from 'clipboard'
    import { extensionDetail } from "apiurl/extension";
    import { adminNoticecontent } from "apiurl/book";
    import Cookies from 'js-cookie'
    /*Facebook Pixel Code*/
    !function(f,b,e,v,n,t,s)
    {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
        n.callMethod.apply(n,arguments):n.queue.push(arguments)};
        if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
        n.queue=[];t=b.createElement(e);t.async=!0;
        t.src=v;s=b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t,s)}(window, document,'script',
        'https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '792143758515863',{'external_id': Cookies.get('udid')});
    fbq('track', 'PageView');
    export default {
        name: "",
        data () {
            return {
                copyCon: '24',
                bookName: '马甲',
                bookCon: '',
                loading: true,
                udid: Cookies.get('udid')
            }
        },
        mounted () {
            this.getCon()
            window.addEventListener('scroll', this.handleScroll, true)
        },
        methods: {
            async getCon () {
                this.loading = true
                let arr = this.GetQueryString('utm_content')?this.GetQueryString('utm_content').split('_'):''
                let res = await adminNoticecontent({id: this.$route.params.id, delCache: 1, utm_campaign: this.GetQueryString('utm_campaign'),
                    utm_content: this.GetQueryString('utm_content'),
                    fbclid:  this.GetQueryString('fbclid'),
                    fbc: Cookies.get('_fbc'),
                    fbp:  Cookies.get('_fbp'),
                    userId: arr[0]?arr[0].substr(1, arr[0].length):'',
                    bookId: arr[1]?arr[1].substr(1, arr[1].length):'',
                    channelId: arr[2]?arr[2].substr(1, arr[2].length):'',
                    appId: arr[3]?arr[3].substr(1, arr[3].length):'',
                });
                if (res.success) {
                    this.loading = false
                    this.bookCon = res.data.noticeContent
                    this.copyCon = res.data.tagNum
                    this.bookName = res.data.noticeTitle
                    document.title = this.bookName
                    this.getDetail(this.bookName, 'load')
                }
            },
            async getDetail (name, action) {
                let res = await extensionDetail(name, action);
            },
            copy () {
                var clipboard = new Clipboard('.download-btn')
                clipboard.on('success', e => {
                    console.log('复制成功')
                    //  释放内存
                    clipboard.destroy()
                })
                clipboard.on('error', e =>{
                    // 不支持复制
                    console.log('该浏览器不支持复制')
                    // 释放内存
                    clipboard.destroy()
                })
            },
            downlowFun (flag) {
                this.copy()
                fbq('track', 'AddToCart');
                // if (flag == 'andriod') {
                //     this.getDetail(this.bookName, 'click')
                //     window.location.href = 'https://play.google.com/store/apps/details?id=com.blackstone.reader'
                // } else {
                //     // this.getDetail(this.bookName, 'click')
                //     window.location.href = 'https://apps.apple.com/us/app/meetfic/id1615532334'
                // }
                this.getDetail(this.bookName, 'click')
                window.location.href = 'https://apps.apple.com/us/app/id6443915856'
            },
            GetQueryString(name) {
                var reg = new RegExp("(^|&)"+ name +"=([^&]*)(&|$)");
                var r = window.location.search.substr(1).match(reg);
                if(r!=null)return  unescape(r[2]); return null;
            },
            handleScroll() {
                var scrollTop = document.documentElement.scrollTop||document.body.scrollTop;
                //变量windowHeight是可视区的高度
                var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
                //变量scrollHeight是滚动条的总高度
                var scrollHeight = document.documentElement.scrollHeight||document.body.scrollHeight;
                //滚动条到底部的条件
                if(scrollTop + windowHeight==scrollHeight){
                    //写后台加载数据的函数
                    this.getDetail(this.bookName, 'finish')
                }
            }
        },
    }
</script>
<noscript><img height="1" width="1" style="display:none"
               src="https://www.facebook.com/tr?id=792143758515863&ev=PageView&noscript=1"
/></noscript>
<!-- End Facebook Pixel Code -->
<style scoped lang="scss">
    @import "../../styles/type8";
    *{
        -moz-user-select:none;
        -webkit-user-select:none;
        user-select:none;
    }
    /deep/.el-loading-spinner{
        position: fixed!important;
        transform: translateY(-50%)!important;
    }
    .page{
        width: 100%;
        height: auto;
        background: #fff;
    }
    .page-content{
        padding-bottom: 6rem;
        /deep/p{
            line-height: 1.6;
            margin-bottom: 20px;
            margin: 0 0 10px;
        }
        /deep/img {
            width: 100%;
        }
        .tipInfo{
            margin: auto;
            text-align: center;
            margin-top: 1rem;
            margin-bottom: 1rem;
            color: #000!important;
            b{
                color: #ff0000;
            }
        }
    }
    .rand_pic{
        width: 100%;
        height: 20.75rem;
    }
    .downloadCon{
        width: 100%;
        text-align: center;
        color: #1f80e3;
        font-size:1.25rem;
        font-weight: bold;
        .name{
            color: #fe3f72;
            font-size: 1.7rem;
        }
        .num{
            color:  #e31f44;
            font-size: 1.65rem;
        }
    }
    .clickImage{
        margin-top: -10px;
        text-align: center;
        img{
            max-width: 100%;
        }
    }
    .center{
        display: inline-block;
        width: 100%;
        position: fixed;
        height: 6rem;
        background: #fff;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.1);
        bottom: 0;
        /*margin: auto;*/
        /*margin-bottom: 20px;*/
        .download-btn {
            width: 85%;
            height: 3.5rem;
            background: #8a61ff;
            display: block;
            margin-left: 7.5%;
            margin-top: 1rem;
            font-size: 1.35rem;
            line-height: 3.5rem;
            text-align: center;
            color: #fff;
            border-radius: 0.5rem;
            font-family: "PingFang SC";
            /*width: 50%;*/
            /*float: left;*/
            /*text-align: right;*/
            /*img{*/
            /*    width: 10.75rem;*/
            /*    height: 2.5rem;*/
            /*}*/
        }
        /*.download-btn:last-child{*/
        /*    text-align: left;*/
        /*    img{*/
        /*        margin-left: 1.25rem;*/
        /*    }*/
        /*}*/
    }
</style>
